import Icon from '@katalon-studio/katalon-ui/Icon';
import React from 'react';
import colors from '../../../scss/colors.scss';

function FileIcon({ color, textSize }) {
  return <Icon
    type="fa-regular"
    name="fa-file"
    textSize={textSize}
    sx={{
      color,
    }}
    boundingSize={null}
    color={null}
  />;
}

FileIcon.defaultProps = {
  color: colors.gray9,
  textSize: '1rem',
};

export default FileIcon;
